// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"95d85995","453":"935420e4","732":"ee450780","977":"efc6410d"}[chunkId] + ".chunk.js");